import thunk from "redux-thunk";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { changeState } from "./reducers/menuMobile/reduce";
import { changePermission } from "./reducers/permissaoUser/reduce";

const rootReducer = combineReducers({ changeState, changePermission });

const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;
